import { configureStore } from "@reduxjs/toolkit";
import reducer from "../feature/transactions/redux/transactionSlice"

const store = configureStore({
    reducer: reducer, // Добавьте редьюсеры здесь
});

export default store;
